<template>
    <div class="w-100">
        <span class="w-100">
            {{ label }}
        </span>
    
        <textarea
            @input="$emit('update:modelValue', $event.target.value)"
            :value="modelValue"
            :class="['w-100 custom-input-transparent']"
            placeholder="Descripción"
            style="min-height:110px;"
        ></textarea>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: [String, null],
            required: true
        },
        label: String
    }
}
</script>